import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom'; // useNavigate in React Router v6+
import styled from 'styled-components';
import err from '../Asset/404.2628e7ac.png'
// Define your brand colors
const colors = {
  primary: '#663cbd',
  accent: '#ffdee3',
  background: '#fff',
  textColor: '#333',
};

// Styled Components for the 404 page
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${colors.background};
`;

const Message = styled.h1`
  color: ${colors.primary};
  font-size: 4rem;
  text-align: center;
`;

const Description = styled.p`
  color: ${colors.textColor};
  font-size: 1.5rem;
  text-align: center;
`;

const Button = styled.button`
  background-color: ${colors.primary};
  color: white;
  padding: 10px 20px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 20px;
  &:hover {
    background-color: ${colors.accent};
  }
`;

const ErrorImage = styled.img`
  max-width: 40%;
  margin-top: 30px;
  border-radius: 10px;
`;

// 404 Page Component
const NotFoundPage = () => {
  useEffect(() => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "/Header.css";
      link.id = "header-css";
  
      document.head.appendChild(link);
  
      return () => {
        document.getElementById("header-css")?.remove();
      };
    }, []);
  const navigate = useNavigate(); // Use useNavigate instead of useHistory

  const goHome = () => {
    navigate('/'); // Navigate to homepage or any other route
  };

  return (
    <Container style={{background:'#111'}}>
      <Message>404 - Page Not Found</Message>
      <Description>The page you're looking for does not exist.</Description>
      <Button onClick={goHome}>Go Back to Home</Button>
      <ErrorImage width={300} src={err} alt="404 Error" />
    </Container>
  );
};

export default NotFoundPage;
